export default "__VITE_ASSET__jkRG$_Lt__"